import React, { useEffect, useState } from 'react';
import './footer.css';
import {FaEnvelope} from 'react-icons/fa';
import {getTaskStats} from '../../common/api';
import { isLogin } from '@repo/utils';
import FeedbackModal from './FeedbackModal';

function Footer() {
    const [taskCount, setTaskCount] = useState(0);
    const [showFeedback, setShowFeedback] = useState(false);

    useEffect(() => {
        // 获取任务总数
        const fetchTaskStats = async () => {
            try {
                const response = await getTaskStats();
                if (response.data && response.data.totalCount) {
                    setTaskCount(response.data.totalCount);
                }
            } catch (error) {
                console.error('获取任务统计失败:', error);
            }
        };

        fetchTaskStats();
    }, []);

    return (<footer className="footer">
        <div id="web_title">
            已处理任务: {taskCount.toLocaleString()} 个
        </div>

        <a id="icp" href="https://www.miit.gov.cn" target="_blank" rel="noopener noreferrer">
            ICP 晋ICP备17006166号-4
        </a>

        <div id="contact_me">
            <FaEnvelope/>
            <span>&nbsp; merge_gpx@126.com</span>
            {isLogin() && (
                <span className="feedback-link" onClick={() => setShowFeedback(true)}>
                    &nbsp;|&nbsp;反馈
                </span>
            )}
        </div>

        <FeedbackModal show={showFeedback} onHide={() => setShowFeedback(false)} />
    </footer>);
}

export default Footer;